import {combineReducers} from 'redux';
import preferenceList from './preferenceList';
import mixedPois from './mixedPois';
import detail from './detail';
import detailNew from './detailNew';
import poiComments from './poiComments';
import favorite from './favorite';

export default combineReducers({
  preferenceList,
  mixedPois,
  detail,
  detailNew,
  poiComments,
  favorite
});



// WEBPACK FOOTER //
// ./src/store/reducers/poi/index.js